<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleReadAll" class="ml-auto">
                    <!-- <font-awesome-icon :icon="['fas', 'user-plus']" style="width:20px" class="color-brown" /> -->
                    <span class="color-brown text-cap">
                        mark all as read
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="messages" style="width: 100%" :row-class-name="setUnredClass">
                    
                    
                    
                    <el-table-column  width="20" >
                        <template #default="scope" >
                            <el-badge is-dot class="item" v-if="!scope.row.read" >
                            </el-badge>
                        </template>
                    </el-table-column>
                    <el-table-column  label="name">
                        <template #default="scope">
                            {{scope.row.name}} 
                            {{scope.row.surname}}
                        </template>
                    </el-table-column>
            
                    <el-table-column label="email" prop="email" />
                    <el-table-column label="phone" prop="phone" />
                    <el-table-column label="message" prop="message" />
                    <el-table-column label="addedDate" prop="addedDate" />
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="reply message"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['far', 'comment-dots']" style="width:20px" @click="handleReplyMessage(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="show message"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'eye']" style="width:20px" @click="readMessage(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                                
                        </template>
                    </el-table-column>
                    
                </el-table>
                <div class="text-center">
                    <el-pagination 
                        @current-change="getMessages"
                        layout="prev, pager, next" 
                        :page-count="totalPages"
                        :page-size="pageSize"
                        :hide-on-single-page="true"
                        :current-page="pageNumber"
                    />
                </div>
            </el-card>
        </el-col>
    </el-row>
    <el-dialog
        v-model="showMessageDialog"
        :title="currentMessage.name+ ' Messages'"
        width="40%"
        @close="showReplyMessageForm = false"
    >
        <div  class="p-20 mb-20 user-message">
            {{currentMessage.message}}
        </div>
        <div  class="p-20 mb-20 reply-message" v-for="(reply, index) in currentMessage.replies" :key="index" >
            <div class="d-flex justify-between align-center">
                <h3 class="m-0">
                    {{reply.subject}}
                </h3>
                <span>
                    {{reply.sentDate}}
                </span>
            </div>
            <div>
                {{reply.body}}
            </div>
        </div>
         <el-form 
            class="text-center font-24" 
            ref="replyMessageRef"
            :model="replyMessage"
            :rules="replyMessageRules"
            label-position="top"
            v-if="showReplyMessageForm"
        >

            <el-row :gutter="30">
                
                <el-col :lg="24" :xs="24">
                    <el-form-item  label="subject" prop="subject" >
                        <el-input type="text" v-model="replyMessage.subject"></el-input>    
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :xs="24" class="ckeditor-item">
                    <el-form-item  label="body" prop="body"> 
                        <ckeditor class="" :editor="editor" v-model="replyMessage.body" :config="editorConfig "></ckeditor>  
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :xs="24">
                    <el-form-item>
                        <el-button type="primary" @click="sendReply('replyMessageRef')" class="text-cap">
                            <!-- <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" /> -->
                            send
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            
            
        </el-form>
    </el-dialog>
    
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    computed:{
        cachedMessages(){
            return JSON.parse(localStorage.getItem('adminStore'))?.admin.messages || []
        },
        
        cachedLanguages(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.lookups?.languages.list || []
        },
    },
    data(){
        return{
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
               
                // The configuration of the editor.
            },
            showMessageDialog:false,
            showReplyMessageForm:false,
            currentMessage:{},
            messages:[],
            totalPages:0,
            pageSize:0,
            pageNumber:1,
            replyMessage:{
                subject:'',
                body:''
            },
            replyMessageRules:{
                body:[
                    {
                        required:true,
                        message:'field required',
                        trigger:'blur'
                    }
                ],
                subject:[
                    {
                        required:true,
                        message:'field required',
                        trigger:'blur'
                    }
                ]
            }
        }
    },
    mounted(){

        if (!this.cachedMessages.content?.length){
            this.getMessages(this.pageNumber);
        }else{
            this.messages = this.cachedMessages.content;
            this.pageSize = this.cachedMessages.size;
            this.totalPages = this.cachedMessages.totalPages;
            this.pageNumber = this.cachedMessages.pageable.pageNumber + 1;
        }
        
        
    },
    
    methods:{
       
        async getMessages(pageNumber){
            this.pageNumber = pageNumber
            const response = await this.$store.dispatch('getMessages',pageNumber - 1);
            if (response.data.status == 1){
                this.messages = response.data.content;
                this.pageSize = response.data.size;
                this.totalPages = response.data.totalPages;
            }  
        },
      
        async readMessage(message){
            if (!message.read) {
                const response = await this.$store.dispatch('readMessage',message.id);
                if (response.data.status == 1) {
                    this.messages.find(msg => msg.id == message.id).read = true;
                    
                    await this.$store.dispatch('setMessages',this.messages);
                }   
                
            }
            this.showMessageDialog = true;
            this.currentMessage = message;    
            return true        
        },
        async handleReplyMessage(message){
            await this.readMessage(message)
            
            this.showReplyMessageForm = true;
        },
        async handleReadAll(){
            const response = await this.$store.dispatch('readAllMessages');
            if (response.data.status == 1 ){
                await this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
                this.getMessages(this.pageNumber);
                location.reload()
            }
        },
        async sendReply(formName){
            this.$refs[formName].validate(async valid =>{
                if (valid) {
                    let dataToSend = {
                        id:this.currentMessage.id,
                        reply:this.replyMessage
                    }
                    const response = await this.$store.dispatch('sendReply',dataToSend);
                    if (response.data.status == 1 ){
                        this.showMessageDialog = false;
                        this.showReplyMessageForm = false;
                        this.replyMessage = {
                            body:'',
                            subject:'',
                        }
                        this.$notify({
                            title:String(response.status),
                            message:response.data.message,
                            type:'success',
                        });
                        this.getMessages(this.pageNumber);
                    }
                }else{
                    return false
                }
            })
            
        },
       
        setUnredClass(row){
            if (!row.row.read) {
                return 'badge font-bold'
            }
        }
    }
}
</script>
<style lang="scss">
    .user-message {
        border-radius: 0px 50px 50px 50px;
        background-color: cadetblue;
        color: white;
        font-size: 16px;
    }
    .reply-message {
        border-radius: 50px 0px 50px 50px;
        background-color: gray;
        color: white;
        font-size: 16px;
    }
    .ckeditor-item {
        .el-form-item__content {
            width: 100%;
            display: block;
        }
    }
    .badge {
        .el-badge{
                text-align: right;
        }
    }
</style>